export default class Result {
    public creditsWon: number = 0;
    public freespinsWon: number = 0;

}



// WEBPACK FOOTER //
// ./~/slotworks/model/gameplay/records/results/result.ts